import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section className="space-y-16" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-2">
        {/* For You */}
        <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-3">
          <h3 className="font-serif text-2xl text-navy font-bold mb-6 flex items-center gap-3" data-id="element-4">
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-sage text-white text-sm" data-id="element-5">
              <Check className="w-5 h-5" data-id="element-6" />
            </span>
            Esto es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-7">
            {['Sentís picos que te agarran en el día real (trabajo, calle, casa).', 'Necesitás algo privado, rápido y repetible.', 'Estás cansado/a de consejos largos que fallan cuando más los necesitás.', 'Querés recuperar una cosa: agencia sobre tu cuerpo.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80" data-id="element-8">
                <Check className="w-5 h-5 text-sage mt-0.5 shrink-0" data-id="element-9" />
                <span data-id="element-10">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-11">
          <h3 className="font-serif text-2xl text-navy/60 font-bold mb-6 flex items-center gap-3" data-id="element-12">
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-300 text-white text-sm" data-id="element-13">
              <X className="w-5 h-5" data-id="element-14" />
            </span>
            No es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-15">
            {['Querés una “cura total” sin practicar.', 'Buscás terapia completa en un PDF (esto es una herramienta de gestión).', 'Tenés síntomas médicos graves nuevos (ahí se necesita evaluación profesional).'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/60" data-id="element-16">
                <X className="w-5 h-5 text-gray-400 mt-0.5 shrink-0" data-id="element-17" />
                <span data-id="element-18">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="text-center max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-sm border border-navy/5" data-id="element-19">
        <h3 className="font-serif text-2xl text-navy font-bold mb-4" data-id="element-20">
          “¿Y si no me baja en 5 minutos?”
        </h3>
        <p className="text-navy/80 mb-6" data-id="element-21">
          También está contemplado. El kit incluye un{' '}
          <strong data-id="element-22">Plan B de 12 minutos</strong> (sin cambiar la lógica) y un{' '}
          <strong data-id="element-23">anti-rebote de 3 minutos</strong> para evitar que vuelva.
        </p>
      </div>
    </Section>;
}